import RecoverAccountPage from './RecoverAccountPage';

export default RecoverAccountPage;
